import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ConsultaCRM } from '@/features/consulta-crm'
import { requireAdminOrAvaliador } from '@/lib/route-guards'

const searchSchema = z.object({
  crm: z.string().optional(),
  uf: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/consulta-crm/')({
  validateSearch: searchSchema,
  beforeLoad: async () => {
    await requireAdminOrAvaliador()
  },
  component: ConsultaCRM,
})
